import api from '../utils/api';

export const vitalTestService = {
  // Get all vital tests
  getVitalTests: async () => {
    try {
      return await api.get('/admin/test');
    } catch (error) {
      console.error('Error fetching vital tests:', error);
      throw error;
    }
  },

  // Create a new vital test
  createVitalTest: async (vitalTestData) => {
    try {
      return await api.post('/admin/test', { data: vitalTestData });
    } catch (error) {
      console.error('Error creating vital test:', error);
      throw error;
    }
  },

  // Update an existing vital test
  updateVitalTest: async (vitalTestId, vitalTestData) => {
    try {
      return await api.put(`/admin/test/${vitalTestId}`, { data: vitalTestData });
    } catch (error) {
      console.error('Error updating vital test:', error);
      throw error;
    }
  },

  // Delete a vital test
  deleteVitalTest: async (vitalTestId) => {
    try {
      return await api.delete(`/admin/test/${vitalTestId}`);
    } catch (error) {
      console.error('Error deleting vital test:', error);
      throw error;
    }
  },
};
